/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import Img from 'gatsby-image';
import { Row, Col, Banner } from '@everlywell/leaves';

import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { CTA, FluidImageType } from '../../../utils/types';
import { generateKey } from 'utils/helpers';

import * as S from './styles';

export interface HomepageHeroProps {
  headline: string;
  description?: string;
  mainCta?: CTA;
  desktopImage: FluidImageType;
  mobileImage: FluidImageType;
  topBanner?: {
    text: string;
    link: string;
    ctaText: string;
  };
  topBannerCTALink?: string;
  topBannerCTAText?: string;
  topBannerText?: string;
  backgroundColor?: string;
  secondaryHeadline?: string;
  secondaryCtaList?: CTA[];
  listOfContent: Array<{
    heading: string;
    image: {
      fluid: FluidImageType;
      description: string;
    };
  }>;
}

export const HomepageHero = ({
  headline,
  description,
  mainCta,
  desktopImage,
  mobileImage,
  listOfContent,
  backgroundColor,
  topBanner,
  ...rest
}: HomepageHeroProps) => {
  const handleClick = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.HOMEPAGE_HERO_CTA,
      },
    });
  };

  return (
    <S.Section backgroundColor={backgroundColor} {...rest} data-testid="hero">
      {topBanner?.text && topBanner?.link ? (
        <Banner
          text={topBanner.text}
          url={topBanner.link}
          ctaText={topBanner.ctaText}
        />
      ) : null}
      <S.PrimaryContainer>
        <Row middle="md">
          <Col xs={12} sm={12} md={5}>
            <S.Content>
              <S.HeadlineAndDescription>
                {headline ? <S.Headline>{headline}</S.Headline> : null}
                {description ? (
                  <S.Description>{description}</S.Description>
                ) : null}
              </S.HeadlineAndDescription>
              {mainCta ? (
                <S.MainCTA
                  href={mainCta.url}
                  appearance="hero"
                  onClick={handleClick}
                >
                  {mainCta.text}
                </S.MainCTA>
              ) : null}
            </S.Content>
          </Col>
          <Col xs={12} sm={12} md={7}>
            <S.InfoBlockContainer>
              {listOfContent &&
                listOfContent.map((item, i) => (
                  <S.InfoBlock key={generateKey()}>
                    <S.ImgContainer>
                      <Img
                        fluid={item.image.fluid}
                        alt={item.image.description}
                        style={{ width: '164px' }}
                      />
                      <S.NumberTag>{i + 1}</S.NumberTag>
                    </S.ImgContainer>
                    <S.Heading>{item.heading}</S.Heading>
                  </S.InfoBlock>
                ))}
            </S.InfoBlockContainer>
          </Col>
        </Row>
      </S.PrimaryContainer>
    </S.Section>
  );
};

export default HomepageHero;
